import React from 'react';
import Calendar from '../../Components/Calendar/Calendar';
import styles from './GenerarTicket.module.css';
import { FaCalendarAlt } from 'react-icons/fa';

const HistorialServicios = () => {
    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}><FaCalendarAlt style={{ marginRight: '15px' }} /> Agendador de Espacios</h2>
                <p className={styles.subtitle}>Reserva salas de juntas y capacitación de forma sencilla.</p>
            </header>
            <Calendar />
        </div>
    );
};

export default HistorialServicios;
